var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 24,
    viewBox: "0 0 29 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3333 4H18C15.8783 4 13.8434 4.84285 12.3432 6.34315C10.8429 7.84344 10 9.87827 10 12C10 14.1217 10.8429 16.1566 12.3432 17.6569C13.8434 19.1571 15.8783 20 18 20H27.3333V22.6667C27.3333 23.0203 27.1929 23.3594 26.9428 23.6095C26.6928 23.8595 26.3536 24 26 24H2.00001C1.64638 24 1.30724 23.8595 1.0572 23.6095C0.807147 23.3594 0.666672 23.0203 0.666672 22.6667V1.33333C0.666672 0.979711 0.807147 0.640573 1.0572 0.390524C1.30724 0.140476 1.64638 0 2.00001 0H26C26.3536 0 26.6928 0.140476 26.9428 0.390524C27.1929 0.640573 27.3333 0.979711 27.3333 1.33333V4ZM18 6.66667H28.6667V17.3333H18C16.5855 17.3333 15.229 16.7714 14.2288 15.7712C13.2286 14.771 12.6667 13.4145 12.6667 12C12.6667 10.5855 13.2286 9.22896 14.2288 8.22876C15.229 7.22857 16.5855 6.66667 18 6.66667ZM18 10.6667V13.3333H22V10.6667H18Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.ae93359fdf7b1fa3f13a1e22cf902f84.svg";
export { ForwardRef as ReactComponent };